{
    "poolsMicroserviceURL": "https://vuecapacitycttafd.azurefd.net/v1/",
    "capacityMicroserviceURL": "https://vuecapacitycttafd.azurefd.net/v1/",
    "pageTitleSuffix": ""
}